import type { StateCreator, StoreApi, UseBoundStore } from 'zustand';

export type NonProfitPageStore = UseBoundStore<StoreApi<INonProfitSlice>>;

export interface INonProfitSlice {
  nonProfitInitialPaymentPlanGroupId: number;
  nonProfitDisabled: boolean;
}

export const createNonProfitSliceDefaultValues = (): INonProfitSlice => ({
  nonProfitInitialPaymentPlanGroupId: 1,
  nonProfitDisabled: false,
});

export const createNonProfitSlice: StateCreator<INonProfitSlice> = () => createNonProfitSliceDefaultValues();

export const createNonProfitHooks = (pageStore: NonProfitPageStore) => ({
  useDisabled: () => pageStore((state) => state.nonProfitDisabled),
});

export type NonProfitHooks = ReturnType<typeof createNonProfitHooks>;
